import React from "react";
import Layout from "../../layouts/Layout";
import CollectCard from "./CollectCard";
import { connect } from "react-redux";
import actions from "../../redux/actions";
import { useNavigate } from "react-router-dom";
import Lineliff from "../../components/LineLiff";
import apiService from "../../utils/api.service";
import helper from "../../utils/helper";
import _ from "lodash";

class CollectPoint extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      memberId: null,
      data: {
        memberCode: "",
        firstName: "",
        lastName: "",
        identificationNo: "",
        myRecommenderCode: "",
        birthDate: null,
        licenseNo: "",
        education: "",
        recommenderCode: "",
        bank: "",
        bankAccountNo: "",
      },
    };
    this.cbLineLiff = this.cbLineLiff.bind(this);
    this.LoadProfile = this.LoadProfile.bind(this);
  }

  componentDidMount() {
    this.LoadProfile()
  }

  cbLineLiff(e) {
    this.setState({ memberId: e.memberId }, () => this.LoadProfile());
  }

  async LoadProfile() {
    try {
      this.setState({ loading: true });
      const payload = { memberId: this.props?.user?.lineId?.memberId };
      const header = helper.GEN.toValueHeader(this.props);
      const { resData } = await apiService.Profile.SearchMember(
        payload,
        header
      );
      this.setState({ loading: false });
      if (resData.resultCode === "20000") {
        const Resdata = _.cloneDeep(resData.data);
        let { imageProfile, resumeFile, data } = this.state;
        data.memberCode = Resdata.memberCode;
        data.firstName = Resdata.firstName;
        data.lastName = Resdata.lastName;
        data.myRecommenderCode = Resdata.myRecommenderCode;
        data.identificationNo = Resdata.identificationNo;
        data.birthDate = Resdata.birthDate;
        data.licenseNo = Resdata.licenseNo;
        data.education = Resdata.education;
        data.recommenderCode = Resdata.recommenderCode;
        data.point = Resdata.point || "0";

        console.log("data LoadProfile >>", data);
        this.setState({ data, imageProfile, resumeFile });
      }
    } catch (e) {
      console.log("API ERR", e);
    }
  }

  render() {
    const { data } = this.state;
    const linkStyle = { cursor: "pointer", color: "#519DD5", textDecoration: "underline" }
    return (
      <Layout>
        <div className="main-header">
          <CollectCard collectData={data} />
        </div>
        <div className="main-body view3">
          <div className="row">
            <div className="col-xs-12">
              <div className="main-body-header-collect">
                เงื่อนไขการรับแต้มสะสมบุญ
              </div>
              <ul className="detail-body" style={{ listStyle: 'none', marginLeft: '0px' }}>
                <li>
                  1.	ท่านสมัครเป็นสมาชิกรายปี 
                </li>
                <li>
                  2.	ท่านได้ทำงานกับ TNT และชวนเพื่อนมาสมัครเป็นสมาชิก ดูแลเพื่อนอย่างดีเป็นกัลยาณมิตรต่อกัน  หากท่านและเพื่อนยังมีสภาพเป็นสมาชิกรายปี ท่านจะได้ 50 แต้มบุญ/สมาชิก 1 ท่านที่แนะนำ
                </li>
                <li>
                  3.	ท่านสมาชิกรับงานผ่านองค์กร TNT และมีชั่วโมงการทำงาน 140 ชม. ต่อเดือน และไม่ขาด ลา มาสาย ในเวรที่ส่งปฏิบัติงานทั้งหมด ท่านจะได้รับ 200 แต้มบุญ ต่อเดือนนั้น ๆ
                </li>
                <li>
                  4.	ท่านสมาชิกปฏิบัติ ข้อ 1, 2 ท่านจะได้แต้มบุญ  คูณ  2 เท่า ต่อเดือนนั้น ๆ และจะได้รับโบนัสในสิ้น ธค. ของปีถัดไป
                </li>
                <li>
                  5.	ท่านสมาชิกปฏิบัติ ข้อ 1, 2, 3  และปฏิบัติธรรมท่านโกเอนก้าอย่างน้อย 1 ครั้งต่อปี รับแต้มบุญ คูณ 3 เท่า ต่อเดือนนั้น ๆ และจะได้รับโบนัสในสิ้น ธค. ของปีถัดไป 
                  (<span style={linkStyle} onClick={() => {this.props.navigate(`/point-evidence`);}}>แนบหลักฐานการปฏิบัติธรรม</span>)
                </li>
              </ul>
            </div>
          </div>
        </div>
      </Layout>
    );
  }
}

function CollectPointRoute(props) {
  let navigate = useNavigate();
  return <CollectPoint navigate={navigate} {...props} />;
}

const mapStateToProps = (state) => {
  return {
    ...state,
  };
};
export default connect(mapStateToProps, actions)(CollectPointRoute);
